// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","container":"Footer_container__CmmG-","footerSection":"Footer_footerSection__CFEic","footerLogo":"Footer_footerLogo__1NV+0"};